enum AssistantType {
  PARTNER,
  SALES,
}

const INTRODUCED_BY = {
  CUSTOMER: 'CUSTOMER',
  CONNECTOR: 'CONNECTOR',
  PARTNER: 'PARTNER',
  NONE: 'NONE',
} as const;

interface ReferralFieldFormValues {
  introducedBy: (typeof INTRODUCED_BY)[keyof typeof INTRODUCED_BY];
  customerReferral: string;
  connectorReferral: string;
  partnerReferral?: string;
}

interface ReferralFieldErrors {
  introducedBy?: string;
  customerReferral?: string;
  connectorReferral?: string;
  partnerReferral?: string;
}

type IntroducedBy = (typeof INTRODUCED_BY)[keyof typeof INTRODUCED_BY];

export { INTRODUCED_BY, AssistantType };
export type { ReferralFieldFormValues, ReferralFieldErrors, IntroducedBy };
